import React, { useEffect } from 'react';

function Toast({ message, type = 'info', onClose }) {
    const types = {
        success: {
            bgColor: 'bg-green-500',
            icon: 'fa-check-circle'
        },
        error: {
            bgColor: 'bg-red-500',
            icon: 'fa-exclamation-circle'
        },
        info: {
            bgColor: 'bg-blue-500',
            icon: 'fa-info-circle'
        },
        warning: {
            bgColor: 'bg-yellow-500',
            icon: 'fa-exclamation-triangle'
        }
    };

    // Safe message handling - convert any non-string messages to strings
    const safeMessage = typeof message === 'string' 
        ? message 
        : message && typeof message === 'object' && message.toString !== Object.prototype.toString
            ? message.toString()
            : message === null || message === undefined 
                ? '' 
                : JSON.stringify(message);

    useEffect(() => {
        if (onClose) {
            const timer = setTimeout(onClose, 5000);
            return () => clearTimeout(timer);
        }
    }, [onClose]);

    return (
        <div className={`fixed bottom-4 right-4 ${types[type]?.bgColor || types.info.bgColor} text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3 animate-slide-up`}>
            <i className={`fas ${types[type]?.icon || types.info.icon}`}></i>
            <span>{safeMessage}</span>
            {onClose && (
                <button
                    onClick={onClose}
                    className="ml-4 text-white hover:text-gray-200 transition-colors"
                >
                    <i className="fas fa-times"></i>
                </button>
            )}
        </div>
    );
}

export default Toast;
